import React, {useEffect, useState,useRef } from "react";
import "./CalculateArchetype.css";
import ProgressBarChart from "../ProgressBarChart/ProgressBarChart";
import DoughnutChart from "../DoughnutChart/DoughnutChart";
import { END_URL } from "../../config";

function CalculateArchetype({ token, slug, test_slug,TestInfo }) {

  const [secondsLeft, setSecondsLeft] = useState(8);
   const [progressValue, setProgressValue] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const randomCapRef = useRef(
    Math.floor(Math.random() * 10) + 90
  );
    useEffect(() => {
      const interval = setInterval(() => {

        setProgressValue((prev) => {
          if (secondsLeft <= 1) return 100;

          if (prev >= randomCapRef.current) return prev;

          const randomStep = Math.floor(Math.random() * 6) + 2;
          return Math.min(prev + randomStep, randomCapRef.current);
        });
      }, 180);

      return () => clearInterval(interval);
    }, [secondsLeft]);

    const [testData, setTestData] = useState(null);

    useEffect(() => {
      const FetchResultData = async () => {
        try {
          const response = await fetch(
            `${END_URL}/result-loader/${slug}/${test_slug}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          const apiData = await response.json();

          let finalData = apiData;

          if (!apiData?.data?.length) {
            const LocalTest = JSON.parse(localStorage.getItem(slug));

            if (LocalTest?.data?.length && apiData?.catrgory?.length) {
              const mergedResults = LocalTest.data.map((localItem) => {

                const matchedCategory = apiData.catrgory.find(
                  (cat) => cat.id === localItem.category_id
                );

                return {
                  ...localItem,
                  resultcategory: matchedCategory || null,
                };
              });

              finalData = {
                test: apiData.test,
                data: mergedResults,
              };
            }
          }

          setTestData(finalData);

        } catch (error) {
          console.error("Error fetching loader result:", error);
        }
      };

      if (slug && test_slug) FetchResultData();

    }, [slug, test_slug, token]);

  return (
    <div className="test-main1">
      <div className="cal-arche-cont">
        <div className="cal-arche-outer">

          <div className="cal-title-div" dangerouslySetInnerHTML={{ __html:TestInfo?.cal_head_content }}/>
         
          <div className="cal-chart-div">
            <div className="cal-round-chart">
              <DoughnutChart value={progressValue} />
            </div>

            <div className="cal-progress-bar">
              <ProgressBarChart testData={testData} title={TestInfo?.cal_box_title} />
            </div>
          </div>

                <div className="cal-footer">

                    <p>{TestInfo?.cal_bottom_heading}</p>

                 <span>Reveal in {secondsLeft}s</span>
            </div>

        </div>
      </div>
    </div>
  );
}

export default CalculateArchetype;
